import React, { useContext, useMemo } from 'react';
import { useSelector } from 'react-redux';
// CSS
import '../../css/payment.css';
import { getAllPrices } from '../../functions/getPrice';
import Recommendations from '../../recommendations';
import { getOrderTypeSession } from '../../webStorage/manageOrderType';
// Redux
// Design language
import Accordion from '../common/accordion';
import Card from '../common/card';
import Dots from '../common/dots';
import Tag from '../common/tag';

const Accordions = (props) => {
  // Variable Declaration
  const sessionSetting = getOrderTypeSession();
  const restarantSettingFromRedux = useSelector((state) => state.restSetting?.Setting);
  const cartFromRedux = useSelector((state) => state.cart.cart);
  const cartItemsIds = cartFromRedux?.cart_items?.map((item) => item.item_id);
  const { frequentlyAddWithItem, bestSellerItems } = useSelector((state) => state.recommendations);
  const bestSellerItemIds = bestSellerItems.map(({ id }) => id);
  const addOnsId = useMemo(
    () => restarantSettingFromRedux?.addons?.map((addOn) => [...addOn?.itemids]).flat(1),
    [restarantSettingFromRedux]
  );
  let orderType = sessionSetting?.orderType;

  return (
    <div className='menuCard d-flex flex-column gap-2 px-20'>
      {props.body.map(({ items, name, id }, index, array) => {
        const body = items?.map((menuItem, inerIndex) => {
          const allPrices = getAllPrices(menuItem);
          const isItemInBestSeller = id === 'bestseller' || bestSellerItemIds.includes(menuItem.id);
          const showFBT = cartItemsIds?.includes(menuItem.id)
            ? id === 'bestseller' &&
              frequentlyAddWithItem[menuItem.id]?.items?.length &&
              frequentlyAddWithItem[menuItem.id]?.tag === 'bestseller'
              ? true
              : frequentlyAddWithItem[menuItem.id]?.items?.length &&
                frequentlyAddWithItem[menuItem.id]?.tag !== 'bestseller' &&
                id !== 'bestseller'
              ? true
              : false
            : false;

          return (
            <>
              <Card
                key={`menu_${inerIndex}`}
                id={menuItem.id}
                name={menuItem.name}
                clickTrackingURL={menuItem?.clickTrackingURL || ''}
                image={{
                  image_normal: menuItem.img,
                  image_40x40: menuItem.img_40x40,
                  image_175x175: menuItem.img_175x175,
                }}
                imageType={menuItem.image_type}
                description={menuItem.item_desc}
                allPrices={allPrices}
                originalPrice={menuItem.original_price}
                variations={menuItem.variations}
                isCustomizable={menuItem?.variations?.length > 0 || addOnsId.includes(menuItem.id)}
                addOnId={menuItem.addon_ids}
                availability={menuItem.is_available}
                itemStatus={menuItem.status}
                filters={menuItem.filters}
                orderType={orderType}
                itemCode={menuItem?.item_code}
                from='menu'
                cat={menuItem.cat_name}
                subCat={menuItem.subcat_name}
                isLastElementOfMenu={
                  (index == array.length - 1 && inerIndex == items.length - 1) || showFBT
                }
                cardPadding={props.customCardPadding}
                showBestSellerTag={isItemInBestSeller}
                recsType={isItemInBestSeller ? 'best_seller' : ''}
              />
              {showFBT && (
                <Recommendations
                  title={`Frequently added with ${menuItem.name}`}
                  recs={frequentlyAddWithItem[menuItem.id].items}
                  customClass='frequent-recs'
                  showMarker
                  from='menu'
                  recsType='frequently_bought_with'
                  parentItemName={menuItem.name}
                />
              )}
            </>
          );
        });
        return (
          <Accordion
            toggle='true'
            key={index}
            Title={({ toggleTitle }) => (
              <div>
                <span className='d-flex gap-2 fs-16 fw-700 text-capitalize appSubHeader col90'>
                  {String(name).toLowerCase()}
                  <Tag
                    text={items?.length < 10 ? '0' + String(items?.length) : items?.length}
                    tagStyles='h-fit-content'
                  />
                </span>
                {toggleTitle && <hr className='subcategory-line' />}
              </div>
            )}
            menuCard={props.menuCard}
            body={body}
            Dots={() => array.length - 1 !== index && <Dots customClass='mx-3' />}
            isLastElement={index == array.length - 1}
            customTitleStyle='p-0 align-items-start'
          />
        );
      })}
    </div>
  );
};

export default Accordions;
